// h2タグの存在確認
if ($('.column-post h2').length > 0) {
  // 目次を入れる要素を作成
  var $toc = $('<div class="toc inview"><h3>目次</h3><ul></ul></div>');

  // .post内のh2タグを検索
  $('.column-post h2').each(function (index) {
    // h2タグにidを付与
    var id = 'toc-' + (index + 1);
    $(this).attr('id', id);

    // 目次項目を作成
    var title = $(this).text();
    var $listItem = $('<li><a href="#' + id + '">' + title + '</a></li>');

    // 目次に追加
    $toc.find('ul').append($listItem);
  });

  // 目次を.sammaryの後に挿入（.sammaryの存在確認も行う）
  if ($('.sammary').length > 0) {
    $('.sammary').after($toc);

    // スクロールイベントの監視（目次が存在する場合のみ）
    $(window).on('scroll', function () {
      var $target = $('.toc');

      if ($target.length > 0 && !$target.hasClass('fadeInUp')) {
        var targetPosition = $target.offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        if (scroll > targetPosition - windowHeight + 100) {
          $target.addClass('fadeInUp');
        }
      }
    });
  }
}
